import React, { useEffect }  from 'react';
import { Link } from "react-router-dom";
import styled from 'styled-components';

function PaginationComponent(props){
    const pageNumbers =[];
    for(let i =1; i <= Math.ceil(props.totalItem/props.params.size); i++){
        pageNumbers.push(i);
    }

    useEffect(()=>{}, []);

    // eslint-disable-next-line
    return (
        <ModernPaginationContainer>
            <PaginationButton 
                as={Link}
                to={`${props.baseUrl}${pageNumbers[0]}`} 
                onClick={(e)=>{ props.paginate(pageNumbers[0])}} 
                title="First page"
            >
                ⟨⟨
            </PaginationButton>
            <PaginationButton 
                as={Link}
                to={`${props.baseUrl}${parseInt(props.params.page) - 1}`}
                onClick={(e)=>{ props.paginate(parseInt(props.params.page) - 1)}}
                hidden={parseInt(props.params.page) - 1 <= 0}
                title="Previous page"
            >
                ‹
            </PaginationButton>
            
            <PageNumbersContainer>
                {pageNumbers.map(number => 
                    (number > parseInt(props.params.page) - 4) && (number <= parseInt(props.params.page) + 3) ?
                    (<PageNumber 
                        key={number}
                        as={Link} 
                        to={`${props.baseUrl}${number}`} 
                        onClick={(e)=>{ props.paginate(number)}} 
                        isActive={props.params.page == number}
                    >
                        {number}
                    </PageNumber>) 
                    : null
                )}
            </PageNumbersContainer>
            
            <PaginationButton 
                as={Link}
                to={`${props.baseUrl}${parseInt(props.params.page) + 1}`}
                onClick={(e)=>{ props.paginate(parseInt(props.params.page) + 1)}}
                hidden={parseInt(props.params.page) + 1 > pageNumbers.length}
                title="Next page"
            >
                ›
            </PaginationButton>
            <PaginationButton 
                as={Link}
                to={`${props.baseUrl}${pageNumbers[pageNumbers.length-1]}`}
                onClick={(e)=>{ props.paginate(pageNumbers[pageNumbers.length-1])}} 
                title="Last page"
            >
                ⟩⟩
            </PaginationButton>
        </ModernPaginationContainer>
    );
}

const ModernPaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 16px 12px;
  margin: 16px 0;
`;

const PaginationButton = styled.a`
  display: ${props => props.hidden ? 'none' : 'inline-flex'};
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 2px solid #e0e0e0;
  color: #667eea;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-color: #667eea;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const PageNumbersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const PageNumber = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: ${props => props.isActive ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#ffffff'};
  color: ${props => props.isActive ? '#ffffff' : '#333'};
  border: 2px solid ${props => props.isActive ? '#667eea' : '#e0e0e0'};
  font-weight: ${props => props.isActive ? '700' : '600'};
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    ${props => !props.isActive && `
      background-color: #f8f9fb;
      border-color: #667eea;
      color: #667eea;
      transform: scale(1.05);
    `}
  }

  &:active {
    transform: ${props => !props.isActive ? 'scale(0.95)' : 'none'};
  }
`;



export default PaginationComponent;